import { render } from "./SearchIcon.vue?vue&type=template&id=4cebf562"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/SearchIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cebf562"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cebf562', __exports__)) {
    api.reload('4cebf562', __exports__)
  }
  
  module.hot.accept("./SearchIcon.vue?vue&type=template&id=4cebf562", () => {
    api.rerender('4cebf562', render)
  })

}


export default __exports__